import { Badge, Chip } from '@mui/material';
import useUnreadCount from 'hooks/useUnreadCount';
import React from 'react';

interface UnreadIndicatorProps {
  viewId: 'my-chats' | 'not-my-chats' | 'unassigned-chats' | 'bots-chats' | 'chats' | undefined;
  asBadge?: boolean;
  children?: React.ReactNode;
  visible?: boolean;
}

const UnreadIndicator: React.FC<UnreadIndicatorProps> = ({ viewId, asBadge, visible = true, children }) => {
  const unreadCount = useUnreadCount(viewId);

  return asBadge ? (
    <Badge
      badgeContent={unreadCount}
      color="secondary"
      sx={{
        '& .MuiBadge-badge': {
          minWidth: 16,
          height: 16,
        },
      }}
      invisible={unreadCount === 0 || !visible}
      overlap="circular"
    >
      {children}
    </Badge>
  ) : (
    <Chip
      label={unreadCount}
      color={'info'}
      size="small"
      sx={{
        width: 24,
        height: 24,
        '& .MuiChip-label': {
          px: 0.5,
          lineHeight: 1,
        },
      }}
    />
  );
};

export default UnreadIndicator;
